import React from 'react'

type Props = {
  width: string | number
  height: string | number
  fill?: string
}

const IconPrev = ({ width, height, fill = '#1e1e23' }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.47998 12H21.5001" stroke={fill} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M11.0211 4L3 12.0211L11.0211 20" stroke={fill} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IconPrev
